import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import ErrorsBlock from "../../../components/errors/ErrorsBlock";
import { equipmentStatuses, globalTriggerTypes } from "../../../enums";
import { useFetch } from "../../../hooks/useFetch";
import { TriggerType } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { SelectButton } from "../../../ui/SelectButton/SelectButton";
import { Switch, SwitchSM } from "../../../ui/Switch/Switch";
import { useAppStore } from "../../../stores/RootStore";

export interface RequestDataType {
  name: string;
  type?: string;
  min_triggered_period: number;
  enabled: boolean;
  sensor_type_id?: number;
  sensor_id?: number;
  status_change_to: string;
  string_value_equal?: string;
  value_less_than?: number;
  value_more_than?: number;
}

const AddTrigger = ({ closeEditModal }: { closeEditModal: Function }) => {
  const store = useAppStore()
  const [triggers, setTriggers] = useOutletContext<[TriggerType[], Function]>();

  const statusChangedToList = equipmentStatuses.map((status) => {
    return { value: status, label: t(status) };
  });

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control, watch, setValue } = useForm({
    defaultValues: {
      name: "",
      type: null,
      enabled: true,
      min_triggered_period: 10,
      status_change_to: null,
      card: "",
    },
  });

  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] =
    useFetch(`/directories/triggers`);

  let requestData: RequestDataType;
  const onSubmit = (formData: any) => {
    setErrors([]);

    requestData = {
      name: formData.name,
      min_triggered_period: Number(formData.min_triggered_period),
      enabled: formData.enabled,
      status_change_to: formData.status_change_to,
    };

    switch (formData.type) {
      //@ts-ignore
      case "rfid_switch":
        if (!requestData.type) requestData.type = "Sites::Triggers::RfidSwitch";
      //@ts-ignore
      case "rfid_out":
        if (!requestData.type) requestData.type = "Sites::Triggers::RfidOut";
      case "rfid_in":
        if (!requestData.type) requestData.type = "Sites::Triggers::RfidIn";
        requestData.string_value_equal = formData.card;
        break;
    }

    doFetchItemSave({
      method: "POST",
      data: {
        data: requestData,
      },
    });
  };

  const addTrigger = (itemSaveResponse: { data: unknown }) => {
    const newScreenData = itemSaveResponse.data as unknown as TriggerType;
    let newTriggers = [...triggers, newScreenData]
    store.setTriggers(newTriggers)
    setTriggers(newTriggers);
  };

  useEffect(() => {
    if (!saveResponse) return;
    addTrigger(saveResponse);
    reset();
    closeEditModal();
  }, [saveResponse]);

  useEffect(() => {
    if (!saveError) return;
    setErrors(saveError.errors);
    console.log(saveError);
  }, [saveError]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full">
        <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col relative space-y-1">
            <Controller
              name="enabled"
              control={control}
              render={({ field }) => (
                <div className="relative">
                  <div className="flex justify-between items-center py-2">
                    <Label htmlFor="enabled">{field.value ? t("trigger_enabled") : t("trigger_disabled")}</Label>
                    <SwitchSM checked={field.value} onCheckedChange={field.onChange} id="enabled" />
                  </div>
                </div>
              )}
            />
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("trigger_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="type"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("trigger_type")}*</Label>
                  <SelectButton
                    label={"Выберите тип триггера"}
                    searchable={false}
                    options={globalTriggerTypes}
                    value={value ? globalTriggerTypes?.find((s) => s.value == String(value))! : null}
                    onChange={(e) => onChange(e?.value)}
                  />
                </div>
              )}
            />
            <Controller
              name="min_triggered_period"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input type="number" {...field} label={`${t("min_triggered_period")}*`} />
                </div>
              )}
            />
            <Controller
              name="card"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("card")}*`} />
                </div>
              )}
            />

            <Controller
              name="status_change_to"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("status_change_to")}*</Label>
                  <SelectButton
                    label={"Выберите изменение статуса"}
                    searchable={false}
                    options={statusChangedToList}
                    value={value ? statusChangedToList?.find((s) => s.value == String(value))! : null}
                    onChange={(e) => onChange(e?.value)}
                  />
                </div>
              )}
            />
            </div>
          </div>
          <ErrorsBlock errors={errors} />
          <div className="mt-8 flex w-full justify-end">
            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddTrigger;
